import { Component, OnInit, Input, Output } from '@angular/core';

@Component({
    selector: 'app-sns-notification-item',
    templateUrl: './sns-notification-item.component.html',
    styleUrls: ['./sns-notification-item.component.scss']
  })
export class SnsNotificationItemComponent implements OnInit {
  @Input('notification') notification;
  @Input('isGrouped') isGrouped = false;
  @Input('filter') filter = '';
  @Input('message') message = '';

  expirationInDays;

  statusClass = 'success';

  showFullMessage = false;
  showFullGroupMessage = false;

  newSubscriber = '';

  toggleMessage() {
    this.showFullMessage = !this.showFullMessage;
  }
  toggleMessageGroup() {
    this.showFullGroupMessage = !this.showFullGroupMessage;
  }

  constructor() { }

  ngOnInit() {
    // console.log('-------------');
    console.log(this.notification);
    // console.log('-------------');
    // console.log(this.isGrouped);
  }
}

